/**
 * Row data: seeded slot entries (baseline section 5 "Slot registry", plus the reference rail tab
 * of amendments 2.1 section 4), re-owned in 1.0b stage 2 (deliverable 15) to the directories that
 * implement them: `web/types` 1.B-2, `web/documents` 1.I-3, `web/ledger` 1.M-2, `web/links` 1.J,
 * `web/when` 1.O-1, `web/history` 1.V-2, `editor/script` 1.F-2, `web/reference` 1.AB-2, `web/ai`
 * 3.B. Orders and gates are unchanged. CS r4a added the Tidy pill and the app slots' import
 * entries (`web/import`, 2.B-2); CS r5a Phase 2b's Tonight, Run and After entries (`web/sessions`
 * 2.D, `web/run` 2.E, `web/after` 2.F); CS r5b the bootstrap wizard's (`web/bootstrap`, 2.J); CS
 * r6c Phase 2c's Foundry entries and pills (`web/foundry` 2.I-2, `web/sheets/pc` 2.H,
 * `web/sheets/cards` 2.M), appended last. Pure data (excluded from mutation testing).
 */
export const SLOT_ROWS = [
    // Header pills, left to right
    {
        id: 'header.pills.type',
        slot: 'header.pills',
        order: 10,
        owner: '1.B-2',
        directory: 'web/types',
        label: 'Type',
        since: 'exit-1a',
    },
    {
        id: 'header.pills.canon',
        slot: 'header.pills',
        order: 20,
        owner: '1.I-3',
        directory: 'web/documents',
        label: 'Canon status',
        since: 'exit-1a',
    },
    {
        id: 'header.pills.play-discovery',
        slot: 'header.pills',
        order: 30,
        owner: '1.M-2',
        directory: 'web/ledger',
        label: 'Play and discovery',
        since: 'exit-1b',
    },
    {
        id: 'header.pills.home',
        slot: 'header.pills',
        order: 40,
        owner: '1.J',
        directory: 'web/links',
        label: 'Home',
        since: 'exit-1a',
    },
    {
        id: 'header.pills.when',
        slot: 'header.pills',
        order: 50,
        owner: '1.O-1',
        directory: 'web/when',
        label: 'When',
        since: 'exit-1b',
    },
    {
        id: 'header.pills.fields',
        slot: 'header.pills',
        order: 60,
        owner: '1.B-2',
        directory: 'web/types',
        label: 'Filled fields',
        since: 'exit-1a',
    },
    // CS r2c (DECISIONS 150 1.AC-2 item 3): the stat block pill, after the filled fields; CS r4a's
    // import pills are placed by this order.
    {
        id: 'header.pills.statblock',
        slot: 'header.pills',
        order: 70,
        owner: '1.AC-2',
        directory: 'web/sheet-form',
        label: 'Stat block',
        since: 'exit-1b',
    },
    // CS r4a deliverable 109 (2.B-2, `web/import`): the import's pill, after the stat block.
    {
        id: 'header.pills.tidy',
        slot: 'header.pills',
        order: 80,
        owner: '2.B-2',
        directory: 'web/import',
        label: 'Review tidy suggestions',
        since: 'exit-2a',
    },
    // Right-rail tabs, top to bottom
    {
        id: 'rail.tabs.backlinks',
        slot: 'rail.tabs',
        order: 10,
        owner: '1.J',
        directory: 'web/links',
        label: 'Backlinks: relations, mentions with context, unlinked',
        since: 'exit-1a',
    },
    {
        id: 'rail.tabs.outline',
        slot: 'rail.tabs',
        order: 20,
        owner: '1.I-3',
        directory: 'web/documents',
        label: 'Outline',
        since: 'exit-1a',
    },
    {
        id: 'rail.tabs.history',
        slot: 'rail.tabs',
        order: 30,
        owner: '1.V-2',
        directory: 'web/history',
        label: 'History',
        since: 'exit-1a',
    },
    {
        id: 'rail.tabs.cast',
        slot: 'rail.tabs',
        order: 40,
        owner: '1.F-2',
        directory: 'editor/script',
        label: 'Cast',
        since: 'editor-alpha',
    },
    {
        id: 'rail.tabs.chronology',
        slot: 'rail.tabs',
        order: 50,
        owner: '1.O-1',
        directory: 'web/when',
        label: 'Chronology',
        since: 'exit-1b',
    },
    {
        id: 'rail.tabs.inspector',
        slot: 'rail.tabs',
        order: 60,
        owner: '1.J',
        directory: 'web/links',
        label: 'Inspector',
        since: 'exit-1a',
    },
    {
        id: 'rail.tabs.reference',
        slot: 'rail.tabs',
        order: 70,
        owner: '1.AB-2',
        directory: 'web/reference',
        label: 'Reference',
        since: 'exit-1b',
    },
    {
        id: 'rail.tabs.ai',
        slot: 'rail.tabs',
        order: 80,
        owner: '3.B',
        directory: 'web/ai',
        label: 'AI',
        since: 'exit-3a',
    },
    // App slots (CS r4a deliverable 109): the sidebar's Workspace group and the Settings page.
    {
        id: 'shell.workspace.import',
        slot: 'shell.workspace',
        order: 10,
        owner: '2.B-2',
        directory: 'web/import',
        label: 'Import from Notion',
        since: 'exit-2a',
    },
    {
        id: 'settings.sections.import',
        slot: 'settings.sections',
        order: 10,
        owner: '2.B-2',
        directory: 'web/import',
        label: 'Import from Notion',
        since: 'exit-2a',
    },
    // CS r5a deliverable 148 (DECISIONS 212 item 17): Phase 2b's entries, each empty while the
    // `sessions` flag is off; Run and After also off a session's page.
    {
        id: 'shell.top.tonight',
        slot: 'shell.top',
        order: 10,
        owner: '2.D',
        directory: 'web/sessions',
        label: 'Tonight',
        since: 'exit-2b',
    },
    {
        id: 'home.sections.tonight',
        slot: 'home.sections',
        order: 10,
        owner: '2.D',
        directory: 'web/sessions',
        label: 'Tonight',
        since: 'exit-2b',
    },
    {
        id: 'header.modes.run',
        slot: 'header.modes',
        order: 10,
        owner: '2.E',
        directory: 'web/run',
        label: 'Run',
        since: 'exit-2b',
    },
    {
        id: 'page.tabs.after',
        slot: 'page.tabs',
        order: 10,
        owner: '2.F',
        directory: 'web/after',
        label: 'After',
        since: 'exit-2b',
    },
    // CS r5b deliverable 165 (2.J, `web/bootstrap`): the wizard's sidebar entry and Settings section,
    // after the import's (order 20: the import holds 10 in both slots).
    {
        id: 'shell.workspace.bootstrap',
        slot: 'shell.workspace',
        order: 20,
        owner: '2.J',
        directory: 'web/bootstrap',
        label: 'Bootstrap',
        since: 'exit-2b',
    },
    {
        id: 'settings.sections.bootstrap',
        slot: 'settings.sections',
        order: 20,
        owner: '2.J',
        directory: 'web/bootstrap',
        label: 'Bootstrap the campaign',
        since: 'exit-2b',
    },
    // CS r4b deliverable 122 (2.K, `web/views`): the catalogue toolbar's Views controls.
    {
        id: 'catalogue.toolbar.views',
        slot: 'catalogue.toolbar',
        order: 10,
        owner: '2.K',
        directory: 'web/views',
        label: 'Views',
        since: 'exit-2a',
    },
    // CS r6c deliverable 204 (Phase 2c; empty with flag:sheets off): the Foundry import's sidebar
    // entry and Settings section (2.I-2, `web/foundry`), after the bootstrap wizard's (order 30: the
    // import holds 10 and the wizard 20 in both slots); the PC sheet, card and refresh pills between
    // the stat block (70) and Tidy (80).
    {
        id: 'shell.workspace.foundry',
        slot: 'shell.workspace',
        order: 30,
        owner: '2.I-2',
        directory: 'web/foundry',
        label: 'Import from Foundry',
        since: 'exit-2c',
    },
    {
        id: 'settings.sections.foundry',
        slot: 'settings.sections',
        order: 30,
        owner: '2.I-2',
        directory: 'web/foundry',
        label: 'Foundry',
        since: 'exit-2c',
    },
    {
        id: 'header.pills.character',
        slot: 'header.pills',
        order: 72,
        owner: '2.H',
        directory: 'web/sheets/pc',
        label: 'Character sheet',
        since: 'exit-2c',
    },
    {
        id: 'header.pills.card',
        slot: 'header.pills',
        order: 74,
        owner: '2.M',
        directory: 'web/sheets/cards',
        label: 'Card',
        since: 'exit-2c',
    },
    {
        id: 'header.pills.refresh',
        slot: 'header.pills',
        order: 76,
        owner: '2.I-2',
        directory: 'web/foundry',
        label: 'Refresh from Foundry',
        since: 'exit-2c',
    },
];
//# sourceMappingURL=rows-slots.js.map